module.exports = __webpack_public_path__ + "e704fa55f8c558ace37e60dc7c376960.webp";